export interface IProvince{
    id:string,
    name:string,
    abbrev:string,
}

export const PROVINCE_STORE_ACTIONS = {
    RESET_PROVINCES:'PROVINCES:RESET',
}